// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"61155ec8","administration":"1dd28286"}[chunkId] + ".chunk.js";
};